import React from "react";
import * as XLSX from "xlsx";
import { Button } from "reactstrap";
import Loader from "components/Common/Loader";

const DownloadStatement = (props) => {
  const { statementLoading, statements } = props;

  const handleDownload = () => {
    if (!statements || !statements.length) return;

    // 1. Format data and parse numbers
    const data = statements.map((item) => ({
      "Client Login": item.clientLogin,
      "Lots Opened": parseFloat(item.lotsOpened) || 0,
      Commission: parseFloat(item.commission) || 0,
      "Lots Closed": parseFloat(item.lotsClosed) || 0,
      Rebate: parseFloat(item.rebate) || 0,
      "Profit Share": parseFloat(item.profitShare) || 0,
    }));

    // 2. Calculate totals
    const total = {
      "Total Commission": data.reduce((sum, i) => sum + i["Commission"], 0),
      "Total Lots Opened": data.reduce((sum, i) => sum + i["Lots Opened"], 0),
      "Total Lots Closed": data.reduce((sum, i) => sum + i["Lots Closed"], 0),
      "Total Rebate": data.reduce((sum, i) => sum + i["Rebate"], 0),
      "Total Profit Share": data.reduce((sum, i) => sum + i["Profit Share"], 0),
    };

    // 3. Create worksheet from main data
    const worksheet = XLSX.utils.json_to_sheet(data);

    // 4. Create summary section in vertical layout
    const summaryRows = [
      {}, // blank row for spacing
      { "Client Login": "Summary" },
      {
        "Client Login": "Total Commission",
        "Lots Opened": total["Total Commission"],
      },
      {
        "Client Login": "Total Lots Opened",
        "Lots Opened": total["Total Lots Opened"],
      },
      {
        "Client Login": "Total Lots Closed",
        "Lots Opened": total["Total Lots Closed"],
      },
      { 
        "Client Login": "Total Rebate", 
        "Lots Opened": total["Total Rebate"] 
      },
      {
        "Client Login": "Total Profit Share",
        "Lots Opened": total["Total Profit Share"],
      },
    ];

    // 5. Append summary to worksheet
    XLSX.utils.sheet_add_json(worksheet, summaryRows, {
      skipHeader: true,
      origin: -1, // append to the end
    });

    // 6. Export to Excel
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Statement");
    XLSX.writeFile(workbook, "Statement.xlsx");
  };

  return (
    <Button
      color="primary"
      className="btn-light mt-3 mt-lg-0 w-100"
      onClick={handleDownload}
      disabled={statementLoading}
    >
      {statementLoading ? <Loader /> : "Download"}
    </Button>
  );
};

export default DownloadStatement;